import Swiper, { Thumbs, Navigation, Pagination, Zoom, EffectFade } from "swiper/core"

Swiper.use([Thumbs, Navigation, Pagination, Zoom, EffectFade])

const relatedBlogs = {
  initGallery() {
    return new Swiper('.relatedBlogs__slider', {
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: ".relatedBlogs__sliderDots",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        }
      }
    })
  },

  init() {
    this.initGallery()
  }
}

export default relatedBlogs